export default __webpack_public_path__ + "static/events-bg-c4eb0d43660c9ac4f0220b75578d7ae7.png";